import React, { useState, useEffect,} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken } from '../../api/DataApis';
import { GpsBaseURL, Role } from '../../api/DataApis';
import { Link, Navigate, useParams } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';



  const ShippmentLogs = () => {
  // const [corporateData, setCorporateData] = useState([]);
   const [selectedCorporate, setSelectedCorporate] = useState("");
   const [date, setDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [selectedUser, setSelectedUser] = useState('');
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [Isorder, setIsOrder] = useState(false);
  const [selectOrders, setselectOrders] = useState([]);
  const [isgeneration, setisgeneration] = useState("");
  const [InvoiceDownload, setInvoiceDownload] =  useState(false);
  const [searchTerms, setSearchTerms] = useState({
    srNo: '',
    name: '',
    email: '',
    phone: '',
    meterTransactions: '',
    rfids: '',
    wallet: '',
    status: '',
    createdDate: '',
    actions: ''
  });

  const handleCheckboxChange = (orderId) => {
    setSelectedOrders((prevSelected) => {
      if (prevSelected.includes(orderId)) {
        return prevSelected.filter((id) => id !== orderId);
      } else {
        return [...prevSelected, orderId];
      }
    });
  };
  const handleorderCheckboxChange = (orderId) => {
    setselectOrders((prevSelected) => {
      if (prevSelected.includes(orderId)) {
        return prevSelected.filter((id) => id !== orderId);
      } else {
        return [...prevSelected, orderId];
      }
    });
  };

  

  const handleSelectAll = () => {
    if (selectedOrders.length === filteredData.length) {
      setSelectedOrders([]); // Uncheck all
    } else {
      setSelectedOrders(filteredData.map((user) => user?.user_order_id)); // Select all
    }
  };
  const handleSelectAllOrders = () => {
    if (selectOrders.length === filteredData.length) {
      setselectOrders([]); // Uncheck all
    } else {
      setselectOrders(filteredData.map((user) => user?.user_order_id)); // Select all
    }
  };

  let navigate = useNavigate();
  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value
    }));
  };

  const handleReset = (event) => {
    event.preventDefault()
   navigate(`/orders/shippment-logs`);
    }
 document.title = "Shipment Logs";

//  const corporateOptions = corporateData.map(corporate => ({
//   value: corporate._id,
//   label: `${corporate.corporate_name} (${corporate?.email})`,
//   _id: corporate._id,
// }));

// const handlecorporateChange = (selectedOption) => {
//   console.log("selectedOption3wrewgfreh", selectedOption);
//   if(selectedOption) {
//  setSelectedCorporate({ id: selectedOption._id });
//   } else {
//     setSelectedCorporate(null);
//   }
// }
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };



  const fetchproducts = async (page) => {
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/order/shipping-processing-logs?page=${page}`);
   
    
    // Prepare query parameters
    const queryParams = [];
    
    // Add search term to the query params if it's not empty
   
    if (searchQuery) queryParams.push(`searchText=${searchQuery}`);
    //  queryParams.push(`status=Placed`);
    if(selectedCorporate?.id) queryParams.push(`corporate_id=${selectedCorporate?.id}`);
    
    
    const apiUrl = `${apiEndpoint}&${queryParams.join('&')}`;
  
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
     
      setFilteredData(response.data?.data);
      setTotalCount(response.data.count || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.count / response?.data?.limit)); // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchproducts(page);
  }, [searchTerm,  page]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };

  

  
//   const fetchCorporatesData = async () => {
   
//     const apiEndpoint = `${GpsBaseURL}/corporate`;
//     try {
//       const response = await axios.get(apiEndpoint, {
//         headers: {
//           "Content-type": "application/json; charset=UTF-8",
//           Authorization: `Bearer ${uniqueToken}`,
//         },
//       });
//       console.log("Countries response", response);
//       setCorporateData(response.data.data);
//     } catch (error) {
//       console.error("Error fetching countries:", error);
//     } finally {
     
//     }
//   };
// useEffect(() => {
//     if (Role === "false") {
//       fetchCorporatesData();  // Only fetch corporate data if Role === "false"
//     }
//   }, [Role]);
  
  
 const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/order/shipping-processing-logs?page=${page}`;
  //let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/product/`);
  const params = [];
 
  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }
  if (selectedCorporate?.id) {
    params.push(`corporate_id=${selectedCorporate?.id}`);
}
  //
    // params.push(`status=Shipped`);
  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const res = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (res && res?.data && res?.data?.data) {
          setFilteredData(res?.data?.data); // Update filtered data
          setTotalCount(res.data.count || 0); // Set total count based on the filtered data length
          setPageCount(Math.ceil(res?.data?.count / res?.data?.limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};


const handleDownload = (url) => {
  setInvoiceDownload(true);
  if (url) {
    const link = document.createElement('a');
    link.href = url;
    link.download = 'invoice.pdf'; // You can customize the file name here
    link.click();
    setInvoiceDownload(false); // Trigger the download by simulating a click event
  } else {
    alert('Invoice URL is not available.');
    setInvoiceDownload(false);
  }
};







console.log("fileteredData", filteredData);
console.log("selectedOrders", selectedOrders);
console.log("selectdddddddorder", selectOrders);
console.log("Limit", Limit);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">All Shipment Logs({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>

</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
<form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
  <div
    className="row px-3"
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px", // Consistent spacing between elements
      flexWrap: "wrap", // Allow wrapping on smaller screens
    }}
  >
    <div className="col-md-2 col-sm-12">
      <div className="form-group">
        <input
          placeholder="Find Data Here"
          className="form-control"
          style={{
            borderRadius: "8px",
            padding: "6px 10px",
            height: "38px", // Consistent height
          }}
          value={searchQuery}
          onChange={handleSearchTextChange}
        />
      </div>
    </div>

    {/* {Role === "false" && (
      <div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>
        <div className="form-group">
          <Select
            options={corporateOptions}
            onChange={handlecorporateChange}
            value={corporateOptions?.find(option => option.value === selectedCorporate?.id) || null}
            placeholder="Corporate"
            isClearable
            styles={{
              control: (base) => ({
                ...base,
                height: "40px",
                width: "100%", // Make width responsive
                boxShadow: "none",
                minWidth: "0",
                flex: 1,
              }),
            }}
          />
        </div>
      </div>
    )} */}

    <div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>
      {/* Search Button */}
      <button
        className="btn btn-primary"
        onClick={handleSearchSubmit}
        style={{
          marginLeft: "10px",
          height: "38px", // Consistent height
          width: "80px", // Consistent width for the Search button
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 0,
        }}
      >
        Search
      </button>

      {/* Reset Button */}
      <button
        className="btn btn-primary"
        onClick={handleReset}
        style={{
          marginLeft: "10px",
          height: "38px", // Consistent height
          width: "80px", // Slightly smaller width for Reset button
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 0,
        }}
      >
        Reset
      </button>
    </div>
    {Isorder && (
  <div className="spinner-border"/>
)}

    {/* {selectedOrders.length > 0 && (
      <div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>
        <button
          className="btn btn-primary"
          onClick={handleShipment}
          style={{
            marginLeft: "10px",
            height: "38px",
            width: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
            gap: "8px",
          }}
          disabled={Isorder}
        >
          {Isorder ? (
            <>
              <div className="spinner"></div>
              Loading
            </>
          ) : (
            "Shipment"
          )}
        </button>
      </div>
    )} */}
  </div>
</form>

</div>



              <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>
 
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Sr No</th>
    
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Title</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Comment</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Shipping Count</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Status</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Type</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>CreatedBy</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>CreatedAt</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Action</th>
 
   </tr>
</thead>

        <tbody> 
          {filteredData?.map((user, index) => (
            <tr key={index}>
           

              <td>{(page - 1) * Limit + index + 1}</td>
        
       <td>{user?.title}</td>
       <td>{user?.comment}</td>
      
      <td>{user?.shippingLogCount}</td>
      <td> <button
    style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center",     // Centers content vertically
      backgroundColor: 
        user?.status === 'Pending' ? 'yellow' :
        user?.status === 'Completed' ? 'green' :
         user?.status ===  'Processing' ? 'Orange' : "Purple",  // Default color
    }}
    className="btn"
  >
    {user?.status}
  </button></td>
      <td>{user?.type}</td>
        <td>{user?.created_by}</td> 
        <td>{user?.createdAt}</td> 
        
        <td>
        {user?.status === "Completed" && user?.type !== "AWB" && (
          <button 
            className="btn btn-success" 
            onClick={() => handleDownload(user?.invoice_url)} // Pass the invoice URL to the handler
          >
            PDF Download
          </button>
        )}
      </td>
            
      
  </tr>
          ))}   
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default ShippmentLogs;
